import PhoneInputWithCountrySelect from 'react-phone-number-input/react-hook-form';
import styled from 'styled-components/macro';

export const FormPhoneInputStyled = styled(PhoneInputWithCountrySelect)`
  border: ${({ theme }) => `${theme.borders.sm} ${theme.colors.primary.variant3}`};
  line-height: 22px;
  padding: 0.5rem 0.625rem;
  border-radius: ${({ theme }) => theme.radius.sm};

  input {
    margin-left: 0.5rem;
    color: ${({ theme }) => theme.colors.primary.variant11};
    font-size: ${({ theme }) => theme.fontSize.xl};
    font-weight: ${({ theme }) => theme.fontWeight.normal};
    font-family: ${({ theme }) => theme.fontFamily.primary};
    border: none;
  }
`;

export const LabelStyled = styled.label`
  display: block;
  margin-bottom: 0.25rem;
  color: ${({ theme }) => theme.colors.primary.variant9};
`;

export const RequiredSignStyled = styled.span`
  color: ${({ theme }) => theme.colors.highlight.variant2};
`;
